import { showError } from '../../Components/reuse/Toast';
import api from '../../api/axios';

// Action Types
export const GET_EMAIL_SETTINGS_REQUEST = 'GET_EMAIL_SETTINGS_REQUEST';
export const GET_EMAIL_SETTINGS_SUCCESS = 'GET_EMAIL_SETTINGS_SUCCESS';
export const GET_EMAIL_SETTINGS_FAILURE = 'GET_EMAIL_SETTINGS_FAILURE';

export const CREATE_EMAIL_SETTINGS_REQUEST = 'CREATE_EMAIL_SETTINGS_REQUEST';
export const CREATE_EMAIL_SETTINGS_SUCCESS = 'CREATE_EMAIL_SETTINGS_SUCCESS';
export const CREATE_EMAIL_SETTINGS_FAILURE = 'CREATE_EMAIL_SETTINGS_FAILURE';

export const UPDATE_EMAIL_SETTINGS_REQUEST = 'UPDATE_EMAIL_SETTINGS_REQUEST';
export const UPDATE_EMAIL_SETTINGS_SUCCESS = 'UPDATE_EMAIL_SETTINGS_SUCCESS';
export const UPDATE_EMAIL_SETTINGS_FAILURE = 'UPDATE_EMAIL_SETTINGS_FAILURE';

export const DELETE_EMAIL_SETTINGS_REQUEST = 'DELETE_EMAIL_SETTINGS_REQUEST';
export const DELETE_EMAIL_SETTINGS_SUCCESS = 'DELETE_EMAIL_SETTINGS_SUCCESS';
export const DELETE_EMAIL_SETTINGS_FAILURE = 'DELETE_EMAIL_SETTINGS_FAILURE';

export const SEND_TEST_EMAIL_REQUEST = 'SEND_TEST_EMAIL_REQUEST';
export const SEND_TEST_EMAIL_SUCCESS = 'SEND_TEST_EMAIL_SUCCESS';
export const SEND_TEST_EMAIL_FAILURE = 'SEND_TEST_EMAIL_FAILURE';

// Action Creators
export const getEmailSettings = () => async (dispatch) => {
  dispatch({ type: GET_EMAIL_SETTINGS_REQUEST });
  
  try {
    const response = await api.get('email-settings/get');
    
    if (response.data.success) {
      // Check if data exists and has required properties
      const emailData = response.data.data;
      if (emailData && Object.keys(emailData).length > 0) {
        dispatch({ 
          type: GET_EMAIL_SETTINGS_SUCCESS, 
          payload: emailData 
        });
      } else {
        // No email settings found - set payload to null
        dispatch({ 
          type: GET_EMAIL_SETTINGS_SUCCESS, 
          payload: null 
        });
      }
    } else {
      dispatch({ 
        type: GET_EMAIL_SETTINGS_FAILURE, 
        error: response.data.message || 'Failed to fetch email settings' 
      });
    }
  } catch (error) {
    console.error('Failed to fetch email settings:', error);
    dispatch({ 
      type: GET_EMAIL_SETTINGS_FAILURE, 
      error: 'Failed to fetch email settings' 
    });
    showError('Failed to fetch email settings');
  }
};

export const createEmailSettings = (emailData) => async (dispatch) => {
  dispatch({ type: CREATE_EMAIL_SETTINGS_REQUEST });
  
  try {
    const response = await api.post('email-settings/create', emailData);
    
    if (response.data.success) {
      dispatch({ 
        type: CREATE_EMAIL_SETTINGS_SUCCESS, 
        payload: {
          data: response.data.data,
          message: response.data.message
        }
      });
      // Refresh the email settings after creation
      dispatch(getEmailSettings());
    } else {
      // Handle validation errors or other API errors
      const errorMessage = response.data.message || 'Failed to create email settings';
      const validationErrors = response.data.errors || null;
      
      dispatch({ 
        type: CREATE_EMAIL_SETTINGS_FAILURE, 
        error: errorMessage,
        validationErrors: validationErrors
      });
      
      // Show the main error message
      showError(errorMessage);
    }
  } catch (error) {
    console.error('Failed to create email settings:', error);
    dispatch({ 
      type: CREATE_EMAIL_SETTINGS_FAILURE, 
      error: 'Failed to create email settings' 
    });
    showError('Failed to create email settings');
  }
};

export const updateEmailSettings = (emailData) => async (dispatch) => {
  dispatch({ type: UPDATE_EMAIL_SETTINGS_REQUEST });
  
  try {
    const response = await api.put('email-settings/update', emailData);
    
    if (response.data.success) {
      dispatch({ 
        type: UPDATE_EMAIL_SETTINGS_SUCCESS, 
        payload: {
          data: response.data.data,
          message: response.data.message
        }
      });
      // Refresh the email settings after update
      dispatch(getEmailSettings());
    } else {
      // Handle validation errors or other API errors
      const errorMessage = response.data.message || 'Failed to update email settings';
      const validationErrors = response.data.errors || null;
      
      dispatch({ 
        type: UPDATE_EMAIL_SETTINGS_FAILURE, 
        error: errorMessage,
        validationErrors: validationErrors
      });
      
      // Show the main error message
      showError(errorMessage);
    }
  } catch (error) {
    console.error('Failed to update email settings:', error);
    dispatch({ 
      type: UPDATE_EMAIL_SETTINGS_FAILURE, 
      error: 'Failed to update email settings' 
    });
    showError('Failed to update email settings');
  }
};

export const deleteEmailSettings = () => async (dispatch) => {
  dispatch({ type: DELETE_EMAIL_SETTINGS_REQUEST });
  
  try {
    const response = await api.delete('email-settings/delete');
    
    if (response.data.success) {
      dispatch({ 
        type: DELETE_EMAIL_SETTINGS_SUCCESS,
        payload: {
          message: response.data.message
        }
      });
      // Refresh the email settings after deletion
      dispatch(getEmailSettings());
    } else {
      dispatch({ 
        type: DELETE_EMAIL_SETTINGS_FAILURE, 
        error: response.data.message || 'Failed to delete email settings' 
      });
      showError(response.data.message || 'Failed to delete email settings');
    }
  } catch (error) {
    console.error('Failed to delete email settings:', error);
    dispatch({ 
      type: DELETE_EMAIL_SETTINGS_FAILURE, 
      error: 'Failed to delete email settings' 
    });
    showError('Failed to delete email settings');
  }
};

export const sendTestEmail = (testEmailData) => async (dispatch) => {
  dispatch({ type: SEND_TEST_EMAIL_REQUEST });
  
  try {
    const response = await api.post('email-settings/outlook/send-email', testEmailData);
    
    if (response.data.success) {
      dispatch({ 
        type: SEND_TEST_EMAIL_SUCCESS, 
        payload: {
          data: response.data.data,
          message: response.data.message || 'Test email sent successfully!'
        }
      });
    } else {
      dispatch({ 
        type: SEND_TEST_EMAIL_FAILURE, 
        error: response.data.message || 'Failed to send test email' 
      });
      showError(response.data.message || 'Failed to send test email');
    }
  } catch (error) {
    console.error('Failed to send test email:', error);
    dispatch({ 
      type: SEND_TEST_EMAIL_FAILURE, 
      error: 'Failed to send test email' 
    });
    showError('Failed to send test email');
  }
};
